import storeModule from '@/store';

export default (next, resource, redirect = 'notifications',) => {

  const currentUser = storeModule.getters['user/user'];
  
  if (!currentUser.permissions) {
    next(false,);
  } else {
    const hasPermission = (currentUser.permissions || []).some(({name,},) => {
      return name === resource;
    },);

    if (!hasPermission) {
      next ({
        name: redirect,
      },);
    }
    next();
  }
  
};
